type Method = 'GET' | 'POST'

export function fetchJSON<T>(
  url: string,
  method: Method = 'GET',
  payload?: any
): Promise<T> {
  const xhr = new XMLHttpRequest()
  let params: string | undefined

  xhr.open(method, url)
  xhr.responseType = 'json'
  xhr.setRequestHeader(
    'Content-Type',
    `application/${
      method === 'GET' ? 'json;charset=UTF-8' : 'x-www-form-urlencoded'
    }`
  )

  if (method === 'POST' && payload) {
    params = Object.entries(payload)
      .reduce(
        (query, [key, value]) => [...query, `${key}=${value}`],
        [] as string[]
      )
      .join('&')
  }

  xhr.send(params)

  return new Promise((resolve, reject) => {
    xhr.onreadystatechange = function handleXHRStateChange() {
      const DONE = 4
      const OK = 200

      if (xhr.readyState === DONE) {
        if (xhr.status === OK) {
          try {
            if (typeof xhr.response === 'string') {
              resolve(JSON.parse(xhr.response))
            } else {
              resolve(xhr.response)
            }
          } catch (error) {
            throw Error(`Error parsing JSON response: ${xhr.responseText}`)
          }
        } else {
          reject(xhr.status)
        }
      }
    }
  })
}

export function debounce(
  fn: () => void,
  wait: number = 100,
  immediate: boolean = false
) {
  let timeout: NodeJS.Timeout | null = null
  return function(this: any) {
    // tslint:disable-next-line: no-this-assignment no-invalid-this
    const context: any = this
    const args: any = arguments
    function later() {
      timeout = null
      if (!immediate) {
        fn.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(later, wait)
    if (callNow) {
      fn.apply(context, args)
    }
  }
}

export function querySelectorAll<T = Element>(
  selector: string,
  root: HTMLElement | Element | Document = document
) {
  return [].slice.call(root.querySelectorAll(selector)) as T[]
}
